import '@/page/ywqnHomePage/views/homeImg'
